/* @flow */
import CAProvinces from 'lib/geo/CAProvince';
import USStates from 'lib/geo/USState';

const validOrgCountries = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
];

export type ValidOrgCountry = 'US' | 'CA';

export const regionsForCountry = {
  US: { label: 'State', regions: USStates },
  CA: { label: 'Province', regions: CAProvinces },
};

export function stateIsValid(stateCode: string, countryCode: ValidOrgCountry) {
  return regionsForCountry[countryCode].regions.some(region => region.value === stateCode);
}

export function countryIsValid(countryCode: string) {
  return validOrgCountries.some(c => c.value === countryCode);
}

export default validOrgCountries;
